import React, { useRef } from 'react';

import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import ProfileFieldsEdit from 'apps/auth/components/profile/ProfileFieldsEdit';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';

const UpdateLegacyInfoPage = () => {
    const { backUrl } = useExtra();
    const popupRef = useRef(null);

    return (
        <>
            <CommonPage backUrl={backUrl || AUTH_SEND_MAIN_LINK} hasBottomPanel showChat={false}>
                <ProfileFieldsEdit popupRef={popupRef} />
            </CommonPage>
            <PopupNew ref={popupRef} />
        </>
    );
};

export default BasePage(UpdateLegacyInfoPage);
